import React from 'react';

export default function Education(props) {
  return (

    <div id='education' className='-z-50 md:pl-[350px] pl-14 pr-14 pb-16 flex flex-col space-y-4 ' onMouseOver={() => props.onHover("resume")}>

      <h1 className='text-3xl pt-2 font-[650] text-[#173b6c] '>Education</h1>

      <hr className='relative pb-4 w-12 border-t-4 border-blue-400' />

      <section className="dark:white dark:text-black">
        
          <div className="grid gap-4 md:mx-4 sm:grid-cols-12">

            <div className="relative col-span-12 md:px-4 space-y-6 sm:col-span-12">
              <div className="col-span-12 space-y-12 relative px-4 sm:col-span-8 sm:space-y-8 before:absolute before:top-2 before:bottom-0 before:w-0.5 before:-left-3 before:dark:bg-[#1f5297]">
                <div className="flex flex-col relative before:absolute before:top-2 before:w-4 before:h-4
                before:border-2
                before:border-[#1f5297]
                before:rounded-full before:left-[-35px] before:z-[1] before:dark:bg-white">
                  <div className='flex flex-row items-center justify-between'>
                    <h3 className="text-xl font-semibold tracking-wide">BACHELOR OF TECHNOLOGY </h3>
                    <time className="text-sm tracking-wide uppercase sm:p-2 bg-[#e4edf9] dark:text-black font-semibold ">June 20 - June 24</time>
                  </div>
                  <h3>Computer Science and Engineering</h3>
                  <a className='mt-3 italic text-blue-400' href='https://en.wikipedia.org/wiki/Shri_Guru_Gobind_Singhji_Institute_of_Engineering_and_Technology'>Shri Guru Gobind Singhji Institute of Engineering and Technology (SGGSIET), Nanded</a>
                  <div className='flex flex-row space-x-2'>
                    <button className='p-2 rounded-md mt-2 hover:bg-[#e2e6ea]'>Transcripts</button>
                    <button className='p-2 rounded-md mt-2 hover:bg-[#e2e6ea]'>Projects</button>
                  </div>
                </div>
                <div className="flex flex-col relative before:absolute before:top-2 before:w-4 before:h-4
                before:border-2
                before:border-[#1f5297]
                before:rounded-full before:left-[-35px] before:z-[1] before:dark:bg-white">
                  <div className='flex flex-row items-center justify-between'>
                  <h3 className="text-xl font-semibold tracking-wide">HIGHER SECONDARY EDUCATION
 </h3> 
                  <time className="text-sm tracking-wide uppercase p-2 bg-[#e4edf9] dark:text-black font-semibold ">June 19 - June 20</time>
                  </div>
                  <h3>PCM - Computer Science</h3>
                  <a className='mt-3 italic text-blue-400' href='https://schools.org.in/parbhani/27171000165/late-raosaheb-jamkar-secondary-&-higher-secondary-school-parbhani.html'>LATE RAOSAHEB JAMKAR SECONDARY & HIGHER SECONDARY SCHOOL PARBHANI</a>
                  <div className='flex flex-row space-x-2'>
                    <button className='p-2 rounded-md mt-2 hover:bg-[#e2e6ea]'>Transcripts</button>
                  </div>
                </div>
                <div className="flex flex-col relative before:absolute before:top-2 before:w-4 before:h-4
                before:border-2
                before:border-[#1f5297]
                before:rounded-full before:left-[-35px] before:z-[1] before:dark:bg-white">
                  <div className='flex flex-row items-center justify-between'>
                  <h3 className="text-xl font-semibold tracking-wide">SECONDARY SCHOOL </h3>
                  <time className="text-sm tracking-wide uppercase p-2 bg-[#e4edf9] dark:text-black font-semibold ">June 17 - June 18</time>
                  </div>
                  <h3>10th</h3>
                  <a className='mt-3 italic text-blue-400' href='https://schools.org.in/parbhani/27171000313/aurobindo-akshar-jyoti-english-h-s.html'>AUROBINDO AKSHAR JYOTI ENGLISH H.S., Parbhani</a>
                  <div className='flex flex-row space-x-2'>
                    <button className='p-2 rounded-md mt-2 hover:bg-[#e2e6ea]'>Transcripts</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        
      </section>

    </div>

  )
}
